import type { dettes as Fr } from '../fr/dettes';

const pl = (n: number, un: string, plusieurs: string) => `${n} ${n === 1 ? un : plusieurs}`;

/** « dettes » in English — typed on the French: a missing sentence does not compile. */
export const dettes: typeof Fr = {
  filtres: { tout: 'All', credit: 'On account', oubli: 'Not collected', rendue: 'Vehicle returned' },
  erreurChargement: 'This list could not be loaded.',
  erreurTitre: 'Outstanding balances cannot be displayed',
  titre: 'Outstanding',
  nonSoldes: (n) => `${pl(n, 'rental', 'rentals')} with a balance due`,
  nonRestituees: {
    titre: (n) => `${pl(n, 'vehicle', 'vehicles')} never returned, and not paid`,
    texte: 'The vehicle has not come back and neither has the money. Tell a manager right away.',
  },
  rendues: {
    titre: (n) => `${pl(n, 'vehicle', 'vehicles')} returned without the money coming in`,
    texte: 'While the customer still has the vehicle, you have leverage to chase them; afterwards, all you have left is the phone.',
  },
  anciennes: {
    titre: (n, j) => `${pl(n, 'balance', 'balances')} due for more than ${j} days`,
    texte: 'The vehicle is still out, but the rental should already have been paid.',
  },
  kpi: {
    total: 'Total balance due', totalDetail: (n) => `across ${pl(n, 'rental', 'rentals')}`,
    credit: 'Granted on account', creditDetail: 'pay later was agreed at check-out',
    nonEncaisse: 'Not collected', nonEncaisseDetail: 'not yet collected at the counter',
  },
  quiDoitQuoi: 'Who owes what',
  videAucun: 'Nobody owes you anything',
  videFiltre: 'No balance due in this filter',
  colonnes: {
    client: 'Customer', voiture: 'Vehicle', dossier: 'Rental', fin: 'Rental end',
    total: 'Total', encaisse: 'Collected', resteDu: 'Balance due',
  },
  etat: {
    annulee: 'cancelled — balance due', credit: 'on account', tranches: 'instalments balance',
    nonEncaissee: 'not collected', aVenir: 'upcoming rental',
    nonRendue: ' · vehicle NOT returned', rendue: ' · vehicle returned', clos: ' · agreement closed',
  },
  retard: (n) => `${pl(n, 'day', 'days')} overdue`,
  echueAujourdhui: 'due today',
  enCours: 'rental in progress',
  encaisser: 'Take payment',
  note: 'The balance due is the rental agreement\'s balance, recalculated from the cash register movements: a balance due can never say anything different from the cash register. It drops off this list by itself as soon as the balance reaches zero — there is nothing to tick.',
};
